import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HttpApis from "../../services/HttpApis";
import '../ProfileScreen/style.css';

export default function ProfileScreen() {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const isActivateCodeRoute = location.state?.isActivateCodeRoute || false;

useEffect(() => {
  const fetchAvatars = async () => {
    try {
      const response = await HttpApis.getAllProfile();
      
      if (response.data && response.data.data) {
        setAvatars(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching avatars:", error);
    }
  };
  fetchAvatars();
}, []);

const handleAvatarClick = async (avatarId) => {
  setSelectedAvatar(avatarId);
  
  try {
    await HttpApis.postSetProfile(avatarId);
    localStorage.setItem('selectedAvatar', avatarId);
    navigate("/home");
  } catch (error) {
    console.error("Error setting profile:", error);
    alert("Failed to set profile. Please try again.");
  }
};

  const handleAddProfile = () => {
     navigate("/CreateProfile");
  };

  const handleProfile = () => {
    navigate("/editProfile");
  };

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h1 className="profile-title">Who's watching?</h1>

        <div className="avatar-container">
          {avatars.map((avatar) => (
            <div key={avatar.id} className="avatar-wrapper">
              <button
                onClick={() => handleAvatarClick(avatar.id)}
                className={`avatar-button ${selectedAvatar === avatar.id ? 'selected' : ''}`}
              >
                <img 
                  src={avatar.image_url || avatar.avatar_img} 
                  alt={avatar.name || `Avatar ${avatar.id}`}
                  className="avatar-image"
                />
              </button>
              <p className="avatar-name">{avatar.name || 'User'}</p>
            </div>
          ))}

          <div className="avatar-wrapper">
            <button
              onClick={handleAddProfile}
              className="avatar-button add-profile-button"
            >
              <div className="add-icon">+</div>
            </button>
            <p className="avatar-name">Add Profile</p>
          </div>
        </div>

        <div className="button-container">
          <button
            onClick={handleProfile}
            className="profile-button"
          >
            Profile
          </button>
        </div>
      </div>
    </div>
  );
}
